/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Type_FilterInputs */



/**
* | output |
* | --- |
* | "Job Type Filter" |
*
* @param {Job_Type_FilterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_type_filter = /** @type {((inputs?: Job_Type_FilterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Type_FilterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtre par type de tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jobtypfilter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtro tipo di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтр по типу работы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtro de tipo de trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("职位类型筛选器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("求人種別フィルター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी प्रकार फ़िल्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtro por tipo de trabalho")
	return /** @type {LocalizedString} */ ("Job Type Filter")
});